<template>
  <v-card>
    <v-card-title>{{ $t('config_costes.titulo') }}</v-card-title>
    <v-divider></v-divider>

    <v-card-text>
      <v-row>
        <v-col cols="12" class="d-flex justify-end mb-2">
          <v-btn color="primary" class="mx-2" @click="exportToCSV">
            {{ $t('comun.boton_exportar') }}
          </v-btn>

          <v-btn :disabled="disabled" color="primary" class="mx-2" @click="importFromCSV">
            {{ $t('comun.boton_importar') }}
            <input
              type="file"
              accept=".csv"
              ref="fileInput"
              style="display: none;"
              @change="handleCSVUpload"
            />
          </v-btn>
        </v-col>

        <v-row justify="end" class="w-100">
          <v-col cols="auto">
            <v-btn
              class="btn-guardar"
              v-if="caso_base === true"
              color="primary"
              @click="guardar_costes_generales()"
            >
              {{ $t('pestana_configuracion.guardar') }}
            </v-btn>
          </v-col>
        </v-row>

        <v-col cols="12">
          <v-container>
            <v-row>
              <v-col cols="12">
                <div id="app2">
                  <v-grid
                    theme="material"
                    :source="datos"
                    :columns="columns"
                    canFocus
                    range
                    useClipboard
                    :readonly="disabled"
                    filter
                    resize
                    @afteredit="handleCellEdit"
                  ></v-grid>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <v-dialog v-model="showAlert" max-width="400">
    <v-card>
      <v-card-title class="headline">Advertencia</v-card-title>
      <v-card-text>
        {{ error_msg }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="showAlert = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VGrid from "@revolist/vue3-datagrid";
import JSZip from "jszip";
import axios from "axios";
import store from "../store";
import Swal from "sweetalert2";

export default {
  name: "ComponenteCostes",
  components: { VGrid },

  props: {
  disabled:{ type:Boolean, default:false },
  caso_base:{ type:Boolean, required:true, default:null },
  costes:{ type:Array, default:()=>[] },
  desdeSim:{ required:true, default:false },

  years: {               
    type: Array,
    default: () => [],
  },
  maxRows: { type:Number, default: 8760 },
},

  data() {
    return {
      error_msg: "",
      showAlert: false,
      datos: [],
      columns: [],
      loading: false,
      mensaje_loading: "",
    };
  },

  watch: {
    costes: {
      handler(newVal) {
        this.datos = this.normalizeIncoming(newVal);
        this.setColumns();
      },
      deep: true,
      immediate: true,
    },
     years: {               
    handler() {
      this.datos = this.ensureTemplate(this.datos);
      this.setColumns();
      this.$emit("update:costes", [...this.datos]);
    },
    deep: true,
    immediate: true
  },

    "$i18n.locale"() {
      this.setColumns();
    },
  },

  methods: {
    yearKeys() {
    return (this.years || []).map(String);
  },


  ensureTemplate(input) {
    const years = this.yearKeys();
    const maxRows = this.maxRows;

    if (!years.length) {
      return this.normalizeIncoming(Array.isArray(input) ? input : []);
    }

    const arr = Array.isArray(input) ? input : [];

    // 1) vacío -> plantilla
    if (!arr.length) {
      return Array.from({ length: maxRows }, (_, i) => {
        const row = { periodo: i + 1 };
        years.forEach(y => (row[y] = 0));
        return row;
      });
    }

    const first = arr[0] || {};
    const hasAnnual = first.periodo !== undefined && Object.keys(first).some(k => /^\d{4}$/.test(k));
    const isLegacy = ("Hora" in first) || ("Valor" in first) || (first.periodo !== undefined && "Valor" in first);

    // 2) asegurar que estén todos los años
    if (hasAnnual) {
      return arr.slice(0, maxRows).map((r, idx) => {
        const periodo = Number(r.periodo ?? (idx + 1)) || (idx + 1);
        const row = { ...r, periodo };
        years.forEach(y => {
          const raw = row[y];
          const n = typeof raw === "string" ? Number(raw.replace(",", ".")) : Number(raw);
          row[y] = Number.isFinite(n) ? n : (row[y] ?? 0);
        });
        // limpiar columnas de años fuera de horizonte
        Object.keys(row).forEach(k => {
          if (k !== "periodo" && /^\d{4}$/.test(k) && !years.includes(k)) delete row[k];
        });
        return row;
      });
    }

    // 3) replicar Valor a todos los años
    if (isLegacy) {
      return arr.slice(0, maxRows).map((r, idx) => {
        const periodo = Number(r.periodo ?? r.Hora ?? (idx + 1)) || (idx + 1);
        const rawV = r.Valor ?? r.valor ?? 0;
        const n = Number(String(rawV).replace(",", "."));
        const val = Number.isFinite(n) ? n : 0;

        const row = { periodo };
        years.forEach(y => (row[y] = val));
        return row;
      });
    }

    // 4) cualquier otro formato -> normaliza y añade años
    const norm = this.normalizeIncoming(arr).slice(0, maxRows);
    return norm.map((r) => {
      const row = { ...r };
      years.forEach(y => { if (!(y in row)) row[y] = 0; });
      return row;
    });
  },

  normalizeIncoming(arr) {
    const safe = Array.isArray(arr) ? arr : [];
    return safe.slice(0, this.maxRows).map((row, idx) => {
      const periodo = Number(row.periodo ?? row.Hora ?? (idx + 1)) || (idx + 1);
      return { ...row, periodo };
    });
  },

  setColumns() {
    if (!this.datos.length) return;

    const keys = Object.keys(this.datos[0]);
    this.columns = keys.map(key => ({
      name: key === 'periodo' ? this.$t('simulacion.modulo.precios.hora') : key,
      prop: key,
      size: key === 'periodo' ? 120 : 140,
      readonly: key === 'periodo',
      cellTemplate: (h, props) => {
        const value = props.model[props.prop];
        return h('span', {},
          typeof value === 'number'
            ? value.toLocaleString('es-ES', { minimumFractionDigits: 0, maximumFractionDigits: 20 })
            : (value === 0 ? '0' : (value ?? '0'))
        );
      }
    }));

    const idx = this.columns.findIndex(c => c.prop === 'periodo');
    if (idx !== -1) this.columns.unshift(this.columns.splice(idx, 1)[0]);
  },

  handleCellEdit(event) {
    const { detail } = event;
    if (!detail?.prop || detail.prop === "periodo") return;

    let inputValue = detail.val;
    if (typeof inputValue === "string") inputValue = inputValue.replace(",", ".");
    const n = Number(inputValue);
    const finalValue = isNaN(n) ? 0 : n;

    this.datos[detail.rowIndex][detail.prop] = finalValue;
    this.$emit("update:costes", [...this.datos]);
    this.setColumns();
  },

    async obtener_costes_generales() {
      try {
        this.loading = true;
        this.mensaje_loading = "Cargando costes generales...";

        const response = await axios({
          method: "get",
          url: process.env.VUE_APP_API_BASE_URL + "/api/descargar-costes-generales/",
          withCredentials: true,
          headers: {
            Authorization: "Bearer " + store.state.token,
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
          responseType: "blob",
        });

        const arrayBuffer = await new Promise((resolve, reject) => {
          const fileReader = new FileReader();
          fileReader.onload = () => resolve(fileReader.result);
          fileReader.onerror = reject;
          fileReader.readAsArrayBuffer(response.data);
        });

        const zip = await JSZip.loadAsync(arrayBuffer);
        const fileName = Object.keys(zip.files).find((file) => file.endsWith(".json"));
        if (!fileName) throw new Error("No se encontró un archivo JSON en el ZIP.");

        const jsonContent = await zip.file(fileName).async("string");
        const parsed = JSON.parse(jsonContent);

        this.datos = this.normalizeIncoming(parsed);
        this.setColumns();

        // mandarlo al padre 
        this.$emit("update:costes", [...this.datos]);
      } catch (error) {
        console.error("Error al obtener las costes:", error);
      } finally {
        this.loading = false;
      }
    },

    async guardar_costes_generales() {
      this.loading = true;
      this.mensaje_loading = "Guardando costes base...";

      try {
        await axios.post(
          process.env.VUE_APP_API_BASE_URL + "/api/guardar-costes-generales/",
          this.datos,
          {
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + store.state.token,
              "Content-Type": "application/json",
            },
            responseType: "json",
          }
        );
      } catch (error) {
        console.error("Error al guardar los costes generales:", error);
      } finally {
        this.loading = false;
      }
    },

    exportToCSV() {
      if (!this.columns.length) return;

      // exportamos 
      const headers = this.columns.map((col) => col.prop).join(";");
      const rows = this.datos.map((row) =>
        this.columns
          .map((col) => {
            const value = row[col.prop];
            if (typeof value === "number") {
              return value.toLocaleString("es-ES", { minimumFractionDigits: 0, maximumFractionDigits: 20 });
            }
            return value !== undefined ? value : "";
          })
          .join(";")
      );

      const csvContent = [headers, ...rows].join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = (this.$t("config_costes.descarga") || "passthrough") + ".csv";
      a.click();
      URL.revokeObjectURL(url);
    },

    importFromCSV() {
      this.$refs.fileInput.click();
    },

    handleCSVUpload(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = (e) => {
        const csvData = e.target.result;

        const [headerLine, ...lines] = csvData
          .split("\n")
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        if (!headerLine) return;

        const MAX_ROWS = this.maxRows;
        if (lines.length > MAX_ROWS) {
          Swal.fire({
            icon: "error",
            title: this.$t("mensajes.excel_demasiadas_filas_titulo") || "Demasiadas filas",
            html:
              (this.$t("mensajes.excel_demasiadas_filas_texto") || "El fichero supera el máximo permitido.") +
              `<br><b>${lines.length.toLocaleString()}</b> filas detectadas. Máximo permitido: <b>${MAX_ROWS.toLocaleString()}</b>.`,
            confirmButtonText: "OK",
          });
          event.target.value = "";
          return;
        }

        const headers = headerLine.split(";");
        if (!headers.includes("periodo")) {
          Swal.fire({
            icon: "error",
            title: "CSV inválido",
            text: "Falta la columna 'periodo' en la cabecera.",
          });
          event.target.value = "";
          return;
        }

        const importedData = lines.map((line, idx) => {
          const values = line.split(";");
          const obj = {};

          headers.forEach((h, j) => {
            const raw = values[j] ?? "";

            if (h === "periodo") {
              obj.periodo = Number(String(raw).replace(",", ".")) || (idx + 1);
              return;
            }

            const n = Number(String(raw).replace(",", "."));
            obj[h] = raw === "" ? 0 : (isNaN(n) ? 0 : n);
          });

          return obj;
        });

        this.datos = this.normalizeIncoming(importedData);
        this.setColumns();
        this.$emit("update:costes", [...this.datos]);
      };

      reader.readAsText(file, "UTF-8");
      event.target.value = "";
    },
  },

  mounted() {
    if (!this.desdeSim) {
      this.obtener_costes_generales();
    } else {
      this.datos = this.normalizeIncoming(this.costes);
      this.setColumns();
    }
  },
};
</script>

<style>
#app2 {
  height: 400px;
  width: 100%;
}
revo-grid {
  height: 100%;
  width: 100%;
  font-size: 12px;
}
</style>